// eslint-disable-next-line jira/filename-case
import React, { type ReactElement } from 'react';
import AppIcon from '@atlaskit/icon/core/app';
import {
	BambooIcon,
	BitbucketDataCenterIcon,
	ConfluenceDataCenterIcon,
	ConfluenceIcon,
	JiraDataCenterIcon,
	JiraIcon,
} from '@atlaskit/logo';
import type { ApplicationLinkV3Data } from './CommonApplicationLinkCreationEntity.tsx';

type ProductCategory = 'cloud' | 'dc' | 'generic';

export type TypeDefinition = {
	name: string;
	icon: ReactElement;
	category: ProductCategory;
};

type TypeLookup = { [key: string]: TypeDefinition };

// TODO: Better way of handling Cloud/DC split
export const TypeIdMap: TypeLookup = {
	jira: {
		name: 'Jira',
		icon: <JiraIcon size="medium" label="Jira Cloud" />,
		category: 'cloud',
	},
	confluence: {
		name: 'Confluence',
		icon: <ConfluenceIcon size="medium" label="Confluence Cloud" />,
		category: 'cloud',
	},
	'jira-dc': {
		name: 'Jira DC',
		icon: <JiraDataCenterIcon size="medium" label="Jira DC" />,
		category: 'dc',
	},
	'confluence-dc': {
		name: 'Confluence DC',
		icon: <ConfluenceDataCenterIcon size="medium" label="Confluence DC" />,
		category: 'dc',
	},
	bitbucket: {
		name: 'Bitbucket DC',
		icon: <BitbucketDataCenterIcon size="medium" label="Bitbucket DC" />,
		category: 'dc',
	},
	bamboo: {
		name: 'Bamboo',
		icon: <BambooIcon size="medium" label="Bamboo" />,
		category: 'dc',
	},
	generic: {
		name: 'External Application',
		icon: <AppIcon label="External Application" />,
		category: 'generic',
	},
};

export const lookupType = (dcAwareTypeId: string): TypeDefinition => {
	return TypeIdMap[dcAwareTypeId] || TypeIdMap.generic;
};

export const lookupTypeByTypeId = (typeid: string, isDataCenter: boolean): TypeDefinition => {
	// Handle stash=bitbucket alias
	if (typeid === 'stash') {
		return lookupType('bitbucket');
	}

	// Handle DC types
	if ((typeid === 'jira' || typeid === 'confluence') && isDataCenter) {
		return lookupType(`${typeid}-dc`);
	}

	return lookupType(typeid);
};

export const lookupTypeFromV3Data = (link: ApplicationLinkV3Data): TypeDefinition => {
	const type = link.type;
	// TODO: We can determine if it's DC, but how?
	// if (link.data.applicationVersion !== undefined) {
	// 	type += '-dc';
	// }

	return lookupTypeByTypeId(type, false);
};
